import React, { useId, useState } from 'react';
import './ui.css';

/**
 * A rail card that can be folded away. The whole header is the toggle, so the hit
 * area matches what the eye reads as "the heading".
 *
 * `meta` is a short right-aligned note -- a count, a total -- that stays visible
 * while collapsed, so a folded card still says how much is inside it.
 */
export default function CollapsibleCard({
  title,
  meta,
  defaultOpen = false,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();

  return (
    <div className={`sv-card sv-rail-card sv-collapse ${open ? 'is-open' : ''} ${className}`}>
      {/* Heading wrapping the control, so the rail keeps the same heading outline it
          has for the non-collapsible cards and screen readers can still jump by
          heading. */}
      <h3 className="sv-collapse__heading">
        <button
          type="button"
          className="sv-collapse__head"
          aria-expanded={open}
          aria-controls={bodyId}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`bx bx-chevron-right sv-collapse__chevron ${open ? 'is-open' : ''}`} />
          <span className="sv-rail-card__title sv-collapse__title">{title}</span>
          {meta != null && <span className="sv-collapse__meta sv-mono">{meta}</span>}
        </button>
      </h3>

      {/* Unmounted rather than hidden: these bodies render long lists, and a
          collapsed card should not cost anything to keep on the page. */}
      {open && (
        <div className="sv-collapse__body" id={bodyId}>
          {children}
        </div>
      )}
    </div>
  );
}
